import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_COMPANY_API_URL,
  timeout: 30000,
});

api.interceptors.request.use((config) => {
  const deviceId = localStorage.getItem("device_id");
  if (deviceId) {
    config.headers["X-Device-ID"] = deviceId;
  }

  const token = localStorage.getItem("company_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

export default api;
